import { GetChannelRedirects } from '@/connection/channel/redirects';
import { serializeError } from '@/store/utils/serialize-error';
import { ChannelSettingsReducerCreator } from '../types';

const getRedirectsReducer = (create: ChannelSettingsReducerCreator) => {
  return create.asyncThunk(
    async ({ channel }: { channel: number }, { rejectWithValue }) => {
      try {
        const redirects = await GetChannelRedirects(channel);
        return redirects;
      } catch (error) {
        return rejectWithValue(serializeError(error));
      }
    },
    {
      fulfilled: (state, action) => {
        state.redirects = action.payload;
      },
    }
  );
};

export default getRedirectsReducer;
